import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Users } from 'lucide-react'
import { MembersScreen } from '@/screens/org/SCR-047-members'

export const Route = createFileRoute('/_app/org/members')({
  staticData: { screen: { id: 'SCR-047', title: 'Members & teams', group: 'Organisation', perm: ['identity.manage', 'workspace.read'], order: 2, description: 'Who is in the organisation, their roles and teams, invitations and requests to join.', icon: Users } },
  validateSearch: z.object({
    tab: z.enum(['members', 'invitations', 'teams', 'requests']).optional().catch(undefined),
    q: z.string().max(100).optional().catch(undefined),
    role: z.string().max(80).optional().catch(undefined),
    status: z.enum(['all', 'active', 'disabled']).optional().catch(undefined),
    invite: z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean()).optional().catch(undefined),
  }),
  component: MembersScreen,
})
